import React, { useEffect, useState } from 'react';
import {lineData} from '../../Data/Lines';
import './pkupLines.css';


function PkupLines() {
    const [randomIndex, setRandomIndex] = useState(0);
    const [showLine2, setShowLine2] = useState(false);
  
    useEffect(() => {
      setRandomIndex(Math.floor(Math.random() * lineData.length));
    }, []);
  
    const handleShowLine2 = () => {
      setShowLine2(true);
    };
  
    const handleReload = () => {
        setShowLine2(false);
        setRandomIndex(Math.floor(Math.random() * lineData.length));
    };

  return (
        <div className="pkup-container">
        {showLine2 ? (
            <>
                <p>{lineData[randomIndex].line2}</p>
                <div className="pkup-button-div">
                    <button className='ok-btn'>Awww! Ok</button>
                    <button onClick={handleReload}>Next &#9654;</button>
                </div>
            </>
        ):(
            <>
                <p>{lineData[randomIndex].line1}</p>
                <button onClick={handleShowLine2}>{lineData[randomIndex].cd}</button>
            </>
        )}
        </div>
  )
}

export default PkupLines